var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.163933 0.150665C-0.0347736 0.33329 -0.0528378 0.619067 0.10974 0.820447L0.163933 0.878141L4.64894 5L0.163933 9.12186C-0.0347732 9.30448 -0.0528374 9.59026 0.109741 9.79164L0.163933 9.84933C0.36264 10.032 0.673583 10.0486 0.892696 9.89914L0.955471 9.84933L5.83607 5.36374C6.03477 5.18111 6.05284 4.89534 5.89026 4.69396L5.83607 4.63626L0.95547 0.150665C0.736893 -0.0502218 0.38251 -0.0502218 0.163933 0.150665Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9e33bac90c0e998c44f098fedff4a666.svg";
export { ForwardRef as ReactComponent };